/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const authenticateTelegramResponseDataSchema = z.object({
  userId: z.string(),
  name: z.string(),
  email: z.string(),
  isNewUser: z.boolean(),
  sessionToken: z.string(),
});

export type IAuthenticateTelegramResponseData = z.infer<
  typeof authenticateTelegramResponseDataSchema
>;

export const authenticateTelegramResponseSchema = createApiResponseSchema(
  authenticateTelegramResponseDataSchema,
) as z.ZodSchema<IAPI<IAuthenticateTelegramResponseData>>;

export type IAuthenticateTelegramResponse = IAPI<IAuthenticateTelegramResponseData>;
